import { safeInt } from '../safeInt';

export const setIdIntegrador = (data) => {
    let idIntegrador = 1;
    if (data.integrador != null && typeof data.integrador === "object") {
        if (data.integrador.codigo != null) {
            idIntegrador = safeInt(data.integrador.codigo, 1);
        } else if (data.integrador.idIntegrador != null) {
            idIntegrador = safeInt(data.integrador.idIntegrador, 1);
        }
    } else if (data.integrador != null) {
        idIntegrador = safeInt(data.integrador, 1);
    }

    return idIntegrador;
}